import type { Dict } from "./translate";

export const th: Dict = {
  "lang.choose": "เลือกภาษา",
  "lang.menu": "ภาษา",

  "common.optional": "ไม่บังคับ",
  "common.select": "เลือก",
  "common.cancel": "ยกเลิก",
  "common.search": "ค้นหา{label}…",
  "common.noMatches": "ไม่พบรายการที่ตรงกัน",
  "common.listSep": ", ",

  "page.subtitle": "ใบสมัครร้านค้า",
  "page.referredBy": "แนะนำโดย",
  "page.aBlogicAgent": "ตัวแทนของ BLogic",
  "page.checkingLink": "กำลังตรวจสอบลิงก์ของคุณ…",
  "page.linkUnverifiedTitle": "ตรวจสอบลิงก์นี้ไม่ได้",
  "page.linkUnverifiedBody": "ขณะนี้เรายืนยันลิงก์ใบสมัครนี้ไม่ได้ โปรดรีเฟรชหน้านี้ในอีกสักครู่ หรือขอความช่วยเหลือจากเจ้าหน้าที่ BLogic ที่ติดต่อกับคุณ",
  "page.linkInvalidTitle": "ลิงก์ไม่ถูกต้อง",
  "page.linkInvalidBody": "ลิงก์ใบสมัครนี้ใช้ไม่ได้แล้ว โปรดขอลิงก์ใหม่จากเจ้าหน้าที่ BLogic ที่ติดต่อกับคุณ",
  "page.missingDl": "โปรดเพิ่มรูปใบขับขี่ของคุณ",
  "page.missingCheck": "โปรดเพิ่มรูปเช็คธุรกิจที่ยกเลิกแล้ว (voided check)",
  "page.genericError": "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
  "page.startOverTitle": "ต้องการเริ่มใหม่หรือไม่?",
  "page.startOverBody": "ข้อมูลทั้งหมดที่คุณกรอกไว้ในอุปกรณ์นี้จะถูกล้าง และไม่สามารถกู้คืนได้",
  "page.submit": "ส่งใบสมัคร",
  "dup.title": "ดูเหมือนว่าคุณได้สมัครแล้ว",
  "dup.body": "เราได้รับใบสมัครของ {name} เมื่อ {date} นี่คือธุรกิจเดียวกันหรือไม่?",
  "dup.same": "ใช่ ธุรกิจเดียวกัน — ไม่ต้องส่งซ้ำ",
  "dup.fix": "ใช่ และฉันต้องแก้ไขใบสมัครเดิม",
  "dup.new": "ไม่ใช่ — เป็นสาขาอื่น",
  "dup.replaceTitle": "แทนที่ใบสมัครเดิมหรือไม่?",
  "dup.replaceBody": "ใบสมัครใหม่นี้จะแทนที่ใบสมัครวันที่ {date}",
  "dup.replaceConfirm": "ใช่ แทนที่",
  "dup.back": "ย้อนกลับ",
  "dup.sameDoneTitle": "เรียบร้อยแล้ว",
  "dup.sameDoneBody": "เราได้รับใบสมัครของคุณแล้ว ตัวแทนของคุณจะติดต่อกลับ",
  "dup.updatedTitle": "อัปเดตแล้ว — ขอบคุณ!",
  "dup.updatedBody": "BLogic จะตรวจสอบการเปลี่ยนแปลงของคุณ",

  "done.title": "ได้รับใบสมัครแล้ว",
  "done.body": "ขอบคุณ เจ้าหน้าที่ BLogic จะติดต่อคุณเร็ว ๆ นี้ เพื่อตรวจสอบข้อมูลของคุณและดำเนินการเปิดบัญชีร้านค้าให้เสร็จสมบูรณ์",
  "done.reference": "หมายเลขอ้างอิง: {id}",
  "done.another": "ส่งใบสมัครอีกฉบับ",

  "step.welcome": "ยินดีต้อนรับ",
  "step.legal": "ข้อมูลทางกฎหมาย",
  "step.business": "ธุรกิจ",
  "step.owner": "เจ้าของ",
  "step.bank": "ธนาคาร",

  "wiz.back": "ย้อนกลับ",
  "wiz.continue": "ถัดไป",
  "wiz.submitting": "กำลังส่ง…",
  "wiz.saving": "กำลังบันทึก…",
  "wiz.notSaved": "ยังไม่ได้บันทึก",
  "wiz.saved": "บันทึกแล้วเมื่อ {time}",
  "wiz.restored": "กู้คืนแบบร่างที่บันทึกไว้เมื่อ {time} แล้ว",
  "wiz.startOver": "เริ่มใหม่",
  "wiz.tryAgain": "ลองอีกครั้ง",

  "file.prompt": "ถ่ายรูปหรืออัปโหลด",
  "file.scanning": "กำลังสแกน…",
  "file.unsupported": "ไม่รองรับไฟล์ประเภทนี้",
  "file.uploadedTap": "อัปโหลดสำเร็จ — แตะเพื่อเปลี่ยน",
  "file.uploadedDrop": "อัปโหลดสำเร็จ — วางไฟล์ใหม่หรือเลือกไฟล์เพื่อเปลี่ยน",
  "file.dragDrop": "ลากไฟล์มาวางที่นี่ หรือ",
  "file.browse": "เลือกไฟล์",
  "file.limits": "รูปภาพหรือ PDF ขนาดไม่เกิน {mb} MB",
  "file.previewAlt": "ตัวอย่างของ {name}",
  "file.attached": "แนบแล้ว: {name}",
  "file.remove": "ลบ",
  "file.typeError": "ไม่รองรับไฟล์ประเภทนี้ โปรดเลือกไฟล์ประเภทที่รองรับแทน",
  "file.oneFile": "วางได้ครั้งละหนึ่งไฟล์",
  "file.tooLarge": "ไฟล์นี้มีขนาด {size} MB แต่จำกัดไว้ที่ {max} MB โปรดใช้รูปที่เล็กลงหรือไฟล์สแกนความละเอียดต่ำลง",
  "file.reupload": "โปรดอัปโหลดไฟล์นี้อีกครั้ง",
  "file.previousLead": "ครั้งก่อนคุณแนบ {name} ไว้ ระบบไม่ได้เก็บรูปภาพไว้กับข้อมูลที่บันทึกไว้ โปรดแนบอีกครั้ง",
  "file.previousDl": "ชื่อ วันเกิด และที่อยู่ด้านล่างได้มาจากรูปนั้น",
  "file.previousCheck": "ข้อมูลธนาคารด้านล่างได้มาจากรูปนั้น",

  "conv.message": "เราประมวลผล{names}ของคุณไม่ได้ แตะที่นี่เพื่ออัปโหลดอีกครั้ง",
  "conv.pair": "{a}และ{b}",
  "conv.dl": "ใบขับขี่",
  "conv.check": "เช็คที่ยกเลิกแล้ว",

  "scan.kept": "แนบรูปแล้ว เราเก็บข้อมูลที่คุณกรอกไว้แล้วเหมือนเดิม",
  "scan.firstName": "ชื่อ",
  "scan.middleName": "ชื่อกลาง",
  "scan.lastName": "นามสกุล",
  "scan.dob": "วันเกิด",
  "scan.address": "ที่อยู่",
  "scan.city": "เมือง",
  "scan.state": "รัฐ",
  "scan.zip": "รหัสไปรษณีย์",
  "scan.routing": "เลข Routing",
  "scan.account": "เลขบัญชี",
  "scan.bankName": "ชื่อธนาคาร",

  "welcome.title": "ยินดีต้อนรับสู่ BLogic Systems",
  "welcome.intro": "ขอบคุณที่เลือกร่วมงานกับเรา ใบสมัครสั้น ๆ นี้เป็นขั้นตอนแรกในการเริ่มรับชำระเงิน ใช้เวลาประมาณ 5–10 นาที",
  "welcome.need": "สิ่งที่ต้องเตรียม",
  "welcome.need1": "ชื่อตามกฎหมายของธุรกิจ EIN (เลขประจำตัวผู้เสียภาษีของธุรกิจ) และที่อยู่",
  "welcome.need2": "SSN (หมายเลขประกันสังคม) ของเจ้าของ หรือหนังสือเดินทางและประเทศที่ออก หากไม่ใช่พลเมืองหรือผู้มีถิ่นพำนักในสหรัฐฯ และที่อยู่บ้าน",
  "welcome.need3": "ข้อมูลของเจ้าของหลัก",
  "welcome.need4": "ข้อมูลบัญชีธนาคารของธุรกิจ",
  "welcome.start": "เริ่มต้น",

  "legal.title": "ข้อมูลทางกฎหมาย",
  "legal.subtitle": "โปรดให้ข้อมูลเกี่ยวกับธุรกิจของคุณ",
  "legal.legalName": "ชื่อบริษัท / ชื่อตามกฎหมาย",
  "legal.email": "อีเมล",
  "legal.phone": "เบอร์โทรศัพท์ธุรกิจ",
  "legal.website": "เว็บไซต์",
  "legal.street": "ที่อยู่ (เลขที่และถนน)",
  "legal.zip": "รหัสไปรษณีย์ (ZIP)",
  "legal.state": "รัฐ",
  "legal.city": "เมือง",
  "legal.ownershipType": "รูปแบบการเป็นเจ้าของธุรกิจ",
  "legal.startDate": "วันที่เริ่มกิจการ",
  "legal.ssn": "หมายเลขประกันสังคม (SSN)",
  "legal.ssnHint": "สำหรับกิจการเจ้าของคนเดียว โปรดกรอก SSN ตัวเลข 9 หลัก ในรูปแบบ XXX-XX-XXXX",
  "legal.ein": "เลขประจำตัวนายจ้าง (EIN)",
  "legal.einHint": "ตัวเลข 9 หลัก ในรูปแบบ XX-XXXXXXX",
  "legal.dbaTitle": "DBA (ชื่อทางการค้า)",
  "legal.dbaSubtitle": "ชื่อร้านที่ลูกค้าเห็น หากต่างจากชื่อตามกฎหมาย",
  "legal.dbaSame": "ชื่อ DBA เหมือนกับชื่อตามกฎหมายของคุณหรือไม่?",
  "legal.dbaYes": "ใช่ ใช้ชื่อตามกฎหมาย",
  "legal.dbaNo": "ไม่ ใช้ชื่อ DBA อื่น",
  "legal.dbaName": "ชื่อทางการค้า (DBA)",
  "legal.dbaNamePlaceholder": "ชื่อร้านที่ลูกค้าเห็น",

  "biz.title": "ธุรกิจ",
  "biz.subtitle": "ข้อมูลการรับชำระเงินด้วยบัตรของคุณ",
  "biz.estimates": "ประมาณการยอดรับชำระเงิน",
  "biz.monthly": "ยอดขายรวมต่อเดือน ($)",
  "biz.avgTicket": "ยอดเงินเฉลี่ยต่อรายการ (Ticket) ($)",
  "biz.maxTicket": "ยอดเงินสูงสุดต่อรายการ ($)",
  "biz.product": "คุณขายอะไร?",
  "biz.productPlaceholder": "อธิบายสินค้าหรือบริการของคุณสั้น ๆ",

  "owner.title": "ข้อมูลเจ้าของ",
  "owner.subtitle": "เรายืนยันตัวตนของเจ้าของหลัก กฎของแบรนด์บัตรกำหนดให้มีสัดส่วนการเป็นเจ้าของรวมกันอย่างน้อย 51%",
  "owner.photoLabel": "ถ่ายรูปใบขับขี่ของคุณ",
  "owner.photoHint": "เราจะอ่านชื่อ วันเกิด และที่อยู่จากรูป เพื่อให้คุณไม่ต้องพิมพ์เอง โปรดตรวจสอบข้อมูลอีกครั้งหลังจากนั้น",
  "owner.reading": "กำลังอ่านใบขับขี่…",
  "owner.failed": "เกิดข้อผิดพลาดในการอ่านใบขับขี่ โปรดกรอกข้อมูลด้านล่างเอง",
  "owner.nothingRead": "อ่านข้อมูลจากรูปนั้นไม่ได้ ลองถ่ายให้ชัดและมีแสงสว่างพอ หรือกรอกข้อมูลด้านล่างเอง",
  "owner.prefilled": "กรอกข้อมูลให้แล้ว: {fields} โปรดตรวจสอบทุกช่องและแก้ไขส่วนที่ไม่ถูกต้อง",
  "owner.citizenship": "สถานะพลเมือง",
  "owner.citizenUs": "พลเมืองหรือผู้มีถิ่นพำนักในสหรัฐฯ",
  "owner.citizenNonUs": "ไม่ใช่พลเมืองหรือผู้มีถิ่นพำนักในสหรัฐฯ",
  "owner.firstName": "ชื่อ",
  "owner.middle": "ชื่อกลาง",
  "owner.lastName": "นามสกุล",
  "owner.dob": "วันเกิด",
  "owner.jobTitle": "ตำแหน่ง",
  "owner.ssn": "หมายเลขประกันสังคม (SSN)",
  "owner.ssnHint": "ตัวเลข 9 หลัก ในรูปแบบ XXX-XX-XXXX",
  "owner.passport": "หมายเลขหนังสือเดินทาง",
  "owner.passportHint": "กรอกตามที่ระบุในหนังสือเดินทางของเจ้าของ (ตัวอักษรและตัวเลข)",
  "owner.passportCountry": "ประเทศที่ออกหนังสือเดินทาง",
  "owner.phone": "เบอร์โทรศัพท์",
  "owner.home": "ที่อยู่บ้าน",

  "bank.title": "บัญชีธนาคารของธุรกิจ",
  "bank.subtitle": "บัญชีสำหรับรับเงินยอดขายที่โอนเข้า และชำระค่าธรรมเนียมการรับชำระเงินด้วยบัตร",
  "bank.photoLabel": "ถ่ายรูปเช็คธุรกิจที่ยกเลิกแล้ว",
  "bank.photoHint": "เราจะอ่านเลข Routing และเลขบัญชีจากด้านล่างของเช็ค หนังสือรับรองบัญชีจากธนาคารบนกระดาษหัวจดหมายของธนาคารก็ใช้ได้เช่นกัน",
  "bank.reading": "กำลังอ่านเช็ค…",
  "bank.failed": "เกิดข้อผิดพลาดในการอ่านเช็ค โปรดกรอกเลข Routing และเลขบัญชีเอง",
  "bank.nothingRead": "อ่านข้อมูลจากรูปนั้นไม่ได้ ลองถ่ายให้ชัดและมีแสงสว่างพอ หรือกรอกเลข Routing และเลขบัญชีเอง",
  "bank.prefilled": "กรอกข้อมูลให้แล้ว: {fields} โปรดตรวจสอบให้ตรงกับเช็คของคุณ",
  "bank.bankName": "ชื่อธนาคาร",
  "bank.bankNamePlaceholder": "เช่น Wells Fargo",
  "bank.routing": "เลขที่ธนาคาร (Routing Number)",
  "bank.routingHint": "ตัวเลข 9 หลัก",
  "bank.account": "เลขบัญชี",
  "bank.accountPlaceholder": "เลขบัญชีกระแสรายวัน",
  "bank.accountHint": "ตัวเลขเท่านั้น ไม่เกิน 17 หลัก",
  "bank.accountType": "ประเภทบัญชี",
  "bank.separate": "ใช้บัญชีอื่นสำหรับหักเงินออก (เช่น ค่าธรรมเนียม)",
  "bank.withdrawBank": "ชื่อธนาคารของบัญชีที่ใช้หักเงินออก",
  "bank.withdrawType": "ประเภทบัญชีที่ใช้หักเงินออก",
  "bank.withdrawRouting": "เลขที่ธนาคาร (Routing Number) ของบัญชีที่ใช้หักเงินออก",
  "bank.withdrawAccount": "เลขบัญชีที่ใช้หักเงินออก",
  "bank.notes": "หมายเหตุเพิ่มเติม",
  "bank.notesPlaceholder": "มีอะไรอื่นที่เราควรทราบไหม?",
  "bank.notesHint": "ไม่บังคับ ข้อมูลใด ๆ ที่คุณต้องการให้ทีมพิจารณาอนุมัติ (Underwriting) ทราบ",
  "bank.privacy": "ข้อมูลของคุณถูกส่งอย่างปลอดภัยและมีเพียงเจ้าหน้าที่ BLogic เท่านั้นที่ตรวจสอบ จะไม่มีการเรียกเก็บเงินหรือเปิดบัญชีร้านค้าใด ๆ จนกว่าคุณจะยืนยันข้อมูลกับเจ้าหน้าที่",

  "v.required": "โปรดระบุ{label}",
  "v.digits": "{label} ต้องเป็นตัวเลข {n} หลัก",
  "v.digitsRange": "{label} ต้องเป็นตัวเลข {min}–{max} หลัก",
  "v.zip": "{label} ต้องเป็นตัวเลข 5 หลัก",
  "v.letters": "{label} ต้องเป็นตัวอักษรเท่านั้น",
  "v.tooLong": "{label} ต้องมีความยาวไม่เกิน {max} ตัวอักษร",
  "v.amount": "โปรดกรอกจำนวนเงินที่ถูกต้อง",
  "v.ownershipType": "โปรดเลือกรูปแบบการเป็นเจ้าของธุรกิจ",
  "v.emailRequired": "โปรดกรอกอีเมล",
  "v.emailInvalid": "โปรดกรอกอีเมลที่ถูกต้อง",
  "v.title": "โปรดเลือกตำแหน่ง",
  "v.ssnSole": "ต้องกรอก SSN สำหรับกิจการเจ้าของคนเดียว",
  "v.einRequired": "โปรดกรอก EIN",
  "v.ssnRequired": "โปรดกรอก SSN",
  "v.passportRequired": "โปรดระบุหมายเลขหนังสือเดินทาง",
  "v.passportInvalid": "โปรดระบุหมายเลขหนังสือเดินทางที่ถูกต้อง: ตัวอักษรหรือตัวเลข 5–20 ตัว",
  "v.passportCountryRequired": "โปรดเลือกประเทศที่ออกหนังสือเดินทาง",
  "v.dbaRequired": "โปรดกรอกชื่อ DBA หรือเลือก “{option}”",

  "lbl.dbaName": "ชื่อ DBA",
  "lbl.addressLine2": "ที่อยู่บรรทัดที่ 2",
  "lbl.dbaStreet": "ที่อยู่ของ DBA",
  "lbl.dbaCity": "เมืองของ DBA",
  "lbl.dbaState": "รัฐของ DBA",
  "lbl.dbaZip": "รหัสไปรษณีย์ (ZIP) ของ DBA",
  "lbl.contactName": "ชื่อผู้ติดต่อ",
  "lbl.productDescription": "รายละเอียดสินค้า",
  "lbl.middleName": "ชื่อกลาง",
  "lbl.idNumber": "หมายเลขประจำตัว",
  "lbl.phoneNumber": "เบอร์โทรศัพท์",
  "lbl.mcc": "MCC",
  "lbl.ein": "EIN",
  "lbl.ssn": "SSN",

  "own.Sole Proprietorship": "กิจการเจ้าของคนเดียว (Sole Proprietorship)",
  "own.Partnership": "ห้างหุ้นส่วน",
  "own.General Partnership": "ห้างหุ้นส่วนสามัญ",
  "own.Limited Partnership": "ห้างหุ้นส่วนจำกัด",
  "own.Limited Liability Partnership": "ห้างหุ้นส่วนความรับผิดจำกัด (LLP)",
  "own.LLC": "บริษัทความรับผิดจำกัด (LLC)",
  "own.Corporation - Private": "บริษัทเอกชน (Private Corporation)",
  "own.Corporation - Public": "บริษัทมหาชน (Public Corporation)",
  "own.Professional Association": "นิติบุคคลวิชาชีพ (Professional Association)",
  "own.Non-Profit": "องค์กรไม่แสวงหากำไร",
  "own.Political Organization": "องค์กรทางการเมือง",
  "own.Government": "หน่วยงานรัฐบาล",
  "own.Trust": "ทรัสต์",
  "own.Financial Institution": "สถาบันการเงิน",
  "own.Other": "อื่น ๆ",

  "title.Owner": "เจ้าของ",
  "title.Co-Owner": "เจ้าของร่วม",
  "title.President": "ประธานบริษัท",
  "title.Vice President": "รองประธาน",
  "title.Senior Vice President": "รองประธานอาวุโส",
  "title.Secretary": "เลขานุการ",
  "title.Corporate Secretary": "เลขานุการบริษัท",
  "title.Secretary/Treasurer": "เลขานุการ/เหรัญญิก",
  "title.CEO": "ประธานเจ้าหน้าที่บริหาร (CEO)",
  "title.Controller": "ผู้ควบคุมการเงิน (Controller)",
  "title.Financial Officer": "ผู้บริหารฝ่ายการเงิน (Financial Officer)",
  "title.General Manager": "ผู้จัดการทั่วไป",
  "title.General Partner": "หุ้นส่วนไม่จำกัดความรับผิด (General Partner)",
  "title.Limited Partner": "หุ้นส่วนจำกัดความรับผิด (Limited Partner)",
  "title.Manager": "ผู้จัดการ",
  "title.Member": "สมาชิก (Member)",
  "title.Director": "กรรมการ (Director)",
  "title.Executive Director": "ผู้อำนวยการบริหาร (Executive Director)",

  "acct.Checking": "บัญชีกระแสรายวัน (Checking)",
  "acct.Savings": "บัญชีออมทรัพย์ (Savings)",
};
